import React, { Component } from 'react';
import { Link } from 'react-router';

import './InvoiceList.css';

class InvoiceList extends Component {
  renderInvoiceItem() {
    return (
      [1, 2, 3, 4].map((invoice) => {
        return (
          <tr key={invoice}>
            <td> 02/33/2018 </td>
            <td> $99        </td>
            <td> Spanish GO </td>

            <td>
              <Link> View Invoice </Link>
            </td>
          </tr>
        );
      })
    );
  }

  render() {
    return (
      <div className="InvoiceList">

        <div className="card">
          <div className="card-header bg-secondary">
            <h5 className="text-muted mb-0"> Invoices </h5>
          </div>

          <div className="card-block">

            <table className="table table-responsive table-hover">
              <thead>
                <tr>
                  <th> Date    </th>
                  <th> Amount  </th>
                  <th> Plan    </th>
                  <th> Invoice </th>
                </tr>
              </thead>

              <tbody>
                { this.renderInvoiceItem() }
              </tbody>
            </table>

          </div>
        </div>

      </div>
    );
  }
}

export default InvoiceList;



// WEBPACK FOOTER //
// ./src/components/InvoiceList/InvoiceList.js